/**
 * Tutorial guidato delle Lingue.
 *
 * Nessun preparativo: gli interruttori e il menu non si toccano, perche' salvano
 * subito e cambiano cosa il sito mostra ai visitatori.
 */
const SCOPE = '[data-tour-scope="setting-language"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createLanguageTourSteps() {
	return [
		{
			body: "Le lingue del gestionale e del sito. Ogni lingua accesa qui fa comparire una scheda in piu' in tutte le schede con i testi - prodotti, categorie, pagine - quindi accenderne una e' una decisione che si sente nel lavoro di tutti i giorni.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le lingue',
		},
		{
			body: "Una card per lingua, con due interruttori - Nel gestionale e Sul sito - e l'indicazione di quale e' la predefinita. Sono tre cose diverse e vale la pena non confonderle.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "Nel gestionale accende la lingua dentro il gestionale: e' quella che fa comparire la scheda di traduzione nei moduli. Sul sito invece riguarda il sito pubblico - dice se il visitatore puo' sceglierla. Una lingua puo' essere accesa ma non mostrata: si traduce in pace e si pubblica quando e' pronta.",
			key: 'status',
			placement: 'right',
			target: at('status'),
			title: 'Nel gestionale e sul sito',
		},
		{
			body: "La predefinita e' la lingua principale, segnata dal chip blu: quella che vale quando il visitatore ne parla una che non hai tradotto, e quella che l'elenco dei prodotti usa per mostrare i nomi nel gestionale. Ce n'e' una sola: le altre la diventano dai tre puntini, con Rendi predefinita, e cambiarla cambia il riferimento di tutto il resto.",
			key: 'default',
			placement: 'right',
			target: at('default'),
			title: 'La lingua predefinita',
		},
	];
}
